// // src/Api/Api.js
// export const Api =
//   process.env.NODE_ENV === "production"
//     ? "https://srimurugangroups.com/" // Change to your actual domain
//     : "http://localhost/murugan/"; // If testing locally with XAMPP/LAMP

export const Api =
  process.env.NODE_ENV === "production"
    ? "https://sriaadhilakkshmi.com/erp/" // your own domain if backend is here
    : "http://localhost/erp/server/";
